import InputWithLabel from './InputWithLabel';

export default InputWithLabel;
